export const config = {
	useAnimation: false,
	maxSpeed: 500,
	showFps: false,
	debug: false,
};
